import { Card } from 'antd';
import styles from './DiagramNode.module.css';

const DiagramNode = (props) => {
  return (
    <div className={styles['node-container']}>
      <Card className={styles.node}>
        <Card.Meta title={<span className={styles['node-title']}>{props.title}</span>}></Card.Meta>
      </Card>
      <Card>
        <Card.Meta description={<span className={styles['node-description']}>{props.description}</span>}></Card.Meta>
      </Card>
    </div>
  );
};

export default DiagramNode;
